import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'

export const colunaDisciplinaOrdemNome = (): TabelaColuna => ({
  Chave: 'disciplinaOrdemNome',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => <span>{linha.disciplinaOrdemNome}</span>,
  RenderizarCabecalho: () => (
    <div style={{ width: 150 }}>Disciplina Ordem e Nome</div>
  )
})
